// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The email form (EmailSignup.js): the email gate, the questions-left line
   and "Stay in the loop" in the menu. The field takes the base input style
   (17 px, so iOS never zooms; 52 px tall). */

.email-signup {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.email-signup-promise {
  margin: 0 0 6px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.email-signup-label {
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--brand-muted);
}

.email-signup-error {
  margin: 0;
}

.email-signup-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-top: 4px;
}

.email-signup-fine {
  margin: 2px 0 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: var(--brand-subtle);
}

.email-signup-fine a {
  color: var(--brand-muted);
}

/* The menu's dialog: the title clears the close button. */
.email-dialog .apr-dialog-title {
  padding-right: 44px;
}

.email-dialog-done {
  margin: 4px 0 0;
}

@media (max-width: 720px) {
  .email-signup-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .email-signup-actions .apr-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EmailSignup.css"],"names":[],"mappings":"AAAA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* The email form (EmailSignup.js): the email gate, the questions-left line\n   and \"Stay in the loop\" in the menu. The field takes the base input style\n   (17 px, so iOS never zooms; 52 px tall). */\n\n.email-signup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.email-signup-promise {\n  margin: 0 0 6px;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.email-signup-label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: var(--brand-muted);\n}\n\n.email-signup-error {\n  margin: 0;\n}\n\n.email-signup-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 12px;\n  margin-top: 4px;\n}\n\n.email-signup-fine {\n  margin: 2px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: var(--brand-subtle);\n}\n\n.email-signup-fine a {\n  color: var(--brand-muted);\n}\n\n/* The menu's dialog: the title clears the close button. */\n.email-dialog .apr-dialog-title {\n  padding-right: 44px;\n}\n\n.email-dialog-done {\n  margin: 4px 0 0;\n}\n\n@media (max-width: 720px) {\n  .email-signup-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .email-signup-actions .apr-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
